import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { ShippingProfileCarrierServiceDTO } from '@invenco/sales-interface/interfaces';
import { CarrierDTO, CarrierServiceDTO } from '@invenco/shipping-interface';

import { useGateways } from '../../../../../gateways/GatewayProvider';
import { ComponentData } from '../../../../../shared/types';

type Props = {
  carrierService: ShippingProfileCarrierServiceDTO;
  carriersById?: Record<string, CarrierDTO>;
};

type Models = {
  carrierServiceId: string;
  carrierService: CarrierServiceDTO | undefined;
  carrier: CarrierDTO | undefined;
  isLoadingCarrierService: boolean;
};

export function useStaticCarrierListComponent(props: Props): ComponentData<Models, void> {
  const { shippingGateway } = useGateways();
  const { data: carrierService, isLoading: isLoadingCarrierService } = useQuery({
    queryKey: ['carrierService', props.carrierService.id],
    queryFn: async ({ signal }) =>
      shippingGateway.getCarrierServices({ codes: [props.carrierService.code] }, { signal }),
    select: (data) => data.items[0],
  });

  const [carrier, setCarrier] = useState<CarrierDTO | undefined>(undefined);

  useEffect(() => {
    const foundCarrier =
      props.carriersById && carrierService
        ? props.carriersById[carrierService.carrierId]
        : undefined;
    setCarrier(foundCarrier);
  }, [props.carriersById, carrierService]);

  return {
    models: {
      carrierServiceId: props.carrierService.id,
      carrierService,
      carrier,
      isLoadingCarrierService,
    },
    operations: void 0,
  };
}
